import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e7b3eab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "square_container" }
const _hoisted_2 = { class: "square_container_img_wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "square_menu_wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "基础设置", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "页面配置", -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "观看直播", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "营销互动", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "数据统计", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu_item_text" }, "发起直播", -1))
const _hoisted_12 = { class: "square_meta" }
const _hoisted_13 = { class: "square_meta_tbody meta_info" }
const _hoisted_14 = { class: "square_meta_tbody_title" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "square_meta_tbody_desc" }
const _hoisted_17 = { class: "square_meta_tbody" }
const _hoisted_18 = { class: "square_wrap_tab" }
const _hoisted_19 = { class: "square_wrap_copy" }
const _hoisted_20 = {
  key: 0,
  class: "popover"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_28 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "popover"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全局：", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、多频道引导页", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、微信分享", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "子直播间:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_42 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 2,
  class: "popover"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制内容：", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "全局：", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、全局注册表单", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "子直播间:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1、页面装饰", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2、直播引导页", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、自定义菜单", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4、微信公众号配置", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5、微信分享配置", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6、注册表单", -1))
const _hoisted_54 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "item_select_arrow" }

import { message, Popover, Modal, Tooltip } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import type { RootLive } from '@/store/modules/live/types';
import LiveTab from '@/components/liveItem/LiveTab.vue';
import AppLink from '@/components/AppLink.vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { computed, reactive, ref, createVNode } from 'vue';
import { useDebounce } from '@/hooks/useDebounce';
import http from '@/api';
import { useHomeStore } from '@/pinia/home';

// `qrcode` will be a ref of data URL
interface IProps {
  dataSource: RootLive;
  choice?: boolean;
  selected?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveItemSquare',
  props: {
    dataSource: null,
    choice: { type: Boolean },
    selected: { type: Boolean }
  },
  emits: ['select:changeItemMark', 'click:showLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  dataSource: RootLive;
  choice?: boolean;
  selected?: boolean;
};

const aPopover = Popover;
const aTooltip = Tooltip;
const homeStore = useHomeStore();


const data = reactive(props.dataSource);
const isSelect = computed(() => (props.choice ? 'item_select' : ''));
const isSelected = computed(() => (props.selected ? 'item_selected' : ''));

const setItemSelect = () => {
  if (props.choice) {
    emit('select:changeItemMark', data);
  }
};

const getStudioId = computed(() => {
  if (data.mode === 4 || data.mode === 5) {
    if (data.stream_list && data.mode === 4) {
      return data.stream_list[0].id;
    } else if (data.language_list && data.mode === 5) {
      return data.language_list[0].id;
    }
  }
  return data.id;
});
const getControlId = computed(() => {
  if (data.stream_list && data.mode === 4) {
    return data.stream_list[0].id;
  }
  return data.id;
});

const qrcode = useQRCode(data.qr_code_url, {
  margin: 0,
});

const newStudioId = ref();
const copyChange = useDebounce(() => {
  Modal.confirm({
    content: '此操作将复制直播间的配置，是否继续？',
    centered: true,
    icon: () => createVNode(ExclamationCircleOutlined),
    onOk() {
      emit('click:showLoading', false);
      http.live
        .clickCopy({ studio_id: data.id })
        .then((res) => {
          newStudioId.value = res.data.data;
          message.success(res.data.message);
          window.open(`/live_set/${newStudioId.value}/broad_cast_control`);
        })
        .catch((err) => {
          message.error(err.data.error);
        })
        .finally(() => {
          emit('click:showLoading', true);
        });
    },
  });
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["square_wrap", [_unref(isSelect), _unref(isSelected)]]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (setItemSelect()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "square_container_img",
          src: data.image_player_cover_url
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          type: "link",
          class: "menu_item"
        }, {
          default: _withCtx(() => [
            _createVNode(AppLink, {
              to: `/live_set/${data.id}/broad_cast_control`,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "menu_item_icon",
                  "icon-class": "settings"
                }),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "menu_item"
        }, {
          default: _withCtx(() => [
            _createVNode(AppLink, {
              to: `/pages_editor/${_unref(getStudioId)}/page_director`,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "menu_item_icon",
                  "icon-class": "brush"
                }),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(aPopover), null, {
          content: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(qrcode),
              class: "qr_img",
              alt: "QR Code"
            }, null, 8, _hoisted_7)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "link",
              class: "menu_item"
            }, {
              default: _withCtx(() => [
                _createVNode(AppLink, {
                  to: data.qr_code_url,
                  target: "_block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "menu_item_icon",
                      "icon-class": "tab_type_play"
                    }),
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "menu_item"
        }, {
          default: _withCtx(() => [
            _createVNode(AppLink, {
              to: `/market/${_unref(getStudioId)}/mutually_engage`,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "menu_item_icon",
                  "icon-class": "present"
                }),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "menu_item"
        }, {
          default: _withCtx(() => [
            _createVNode(AppLink, {
              to: `/data_center/${_unref(getStudioId)}/${_unref(homeStore).funcData['LiveData'] ? 'live' : 'questionnaire'}`,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "menu_item_icon",
                  "icon-class": "browser"
                }),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "menu_item"
        }, {
          default: _withCtx(() => [
            _createVNode(AppLink, {
              to: `/console/${_unref(getControlId)}`,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "menu_item_icon",
                  "icon-class": "control"
                }),
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(data.title), 1)
        ]),
        _createElementVNode("span", _hoisted_16, _toDisplayString(data.start_at), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(LiveTab, {
          tabType: "status",
          statusType: data.status,
          size: "sm"
        }, null, 8, ["statusType"]),
        _createVNode(LiveTab, {
          class: "mt10",
          icon: "tab_type_peoples",
          type: "info",
          size: "sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.number > 99999 ? '99999+' : data.number), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(LiveTab, {
        tabType: "mode",
        statusType: data.mode,
        playing: data.live_url_status,
        size: "lg"
      }, null, 8, ["statusType", "playing"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_svg_icon, {
        "icon-class": "copy_list",
        class: "square_wrap_copy_icon"
      }),
      _createVNode(_unref(aTooltip), null, {
        title: _withCtx(() => [
          (data.mode === 0 || data.mode === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_28))
            : _createCommentVNode("", true),
          (data.mode === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_42))
            : _createCommentVNode("", true),
          (data.mode === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_54))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(copyChange) && _unref(copyChange)(...args)), ["stop"])),
            class: "square_wrap_copy_text"
          }, "复制")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createVNode(_component_svg_icon, {
        class: "item_select_arrow_icon",
        "icon-class": "checked"
      })
    ])
  ], 2))
}
}

})